import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { tasks } from '../data/mockData';

export default function Categories() {
  return (
    <section className="py-32 bg-[#faf9f6]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-20">
          <span className="text-red-600 font-bold uppercase tracking-[0.3em] text-xs mb-4 block">Workflow Optimized</span>
          <h2 className="text-4xl md:text-5xl font-black text-zinc-900 tracking-tighter uppercase">Shop by Kitchen Task</h2>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {tasks.map((task, index) => (
            <motion.div
              key={task.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="group cursor-pointer"
            >
              <div className="bg-white border border-zinc-200 p-10 flex flex-col items-center justify-center text-center hover:border-red-600 hover:shadow-[0_20px_50px_rgba(220,38,38,0.1)] transition-all duration-500 relative overflow-hidden group">
                <div className="absolute top-0 left-0 w-1 h-0 bg-red-600 group-hover:h-full transition-all duration-500" />
                <div className="w-20 h-20 rounded-none bg-zinc-50 steel-gradient flex items-center justify-center mb-8 border border-zinc-100 group-hover:scale-110 transition-transform duration-500">
                  <SafeIcon name={task.icon.replace('Fi', '')} className="text-3xl text-zinc-800 group-hover:text-red-600 transition-colors" />
                </div>
                <h3 className="font-black text-xl text-zinc-900 uppercase tracking-tight mb-2">{task.name}</h3>
                <p className="text-xs text-zinc-400 font-bold uppercase tracking-widest">Explore Collection &rarr;</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}